import { Pipe, PipeTransform } from '@angular/core';
import { TranslatableElement, TranslationService } from 'src/app/translation-service.service';



@Pipe({
  name: 'getTranslation'
})
export class GetTranslationPipe implements PipeTransform {
  constructor(
    private translationService: TranslationService
  ) {}

  transform<T extends TranslatableElement >(value: T, field: keyof T, locale: string): string {
    
    return this.translationService.getTranslation(value, field, locale)
    
  }

}
